<template>
    <app-sercheable-data-table
        :headers="headers"
        :search="search"
        :refresh="refresh"
        :pagination="pagination"
    >
        <template slot="afterReloadButton" v-if="!readonly">
            <v-btn
                :to="{ name: 'demandOwnerSubstitutionCreate' }"
                color="primary"
                >{{ $t("label.createDemandOwnerSubstitutions") }}</v-btn
            >
        </template>
        <template slot="items" slot-scope="{ item }">
            <router-link
                :to="{
                    name: 'demandOwnerSubstitutionEdit',
                    params: {
                        id: item.id,
                        demandCode: item.demand.code,
                        demandId: item.demand.id
                    }
                }"
                tag="tr"
            >
                <td>{{ item.demand.code }}</td>
                <td>{{ item.originalOwner | personToString }}</td>
                <td>{{ item.substituteOwner | personToString }}</td>
            </router-link>
        </template>
    </app-sercheable-data-table>
</template>

<script>
// import constants from '@/helpers/constants';
import utilities from "@/helpers/utilities";
import SercheableDataTable from "../shared/SercheableDataTable";

export default {
    data() {
        return {
            pagination: {
                descending: true,
                sortBy: "demand.id"
            },
            headers: [
                {
                    text: this.$t("label.demand"),
                    value: "demand.code",
                    align: "left"
                },
                {
                    text: this.$t("label.originalOwner"),
                    value: "originalOwner.name",
                    align: "left"
                },
                {
                    text: this.$t("label.substitute"),
                    value: "substituteOwner.name",
                    align: "left"
                }
            ]
        };
    },

    computed: {
        readonly() {
            return !this.$store.getters.isAdmin;
        }
    },

    components: {
        appSercheableDataTable: SercheableDataTable
    },

    methods: {
        search(filters) {
            const demandOwnerSubstitutions = this.$store.getters
                .demandOwnerSubstitutions;

            return utilities.filterMultiple(
                demandOwnerSubstitutions,
                filters,
                (demandOwnerSubstitutions, regex) =>
                    regex.test(demandOwnerSubstitutions.demand.code) ||
                    regex.test(demandOwnerSubstitutions.originalOwner.name) ||
                    regex.test(demandOwnerSubstitutions.substituteOwner.name)
            );
        },
        async refresh() {
            await this.$store.dispatch("loadDemandOwnerSubstitutions");
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/demandOwnerSubstitutions/Index.vue